const formatNumber = (num) => {
  if (num === null || num === undefined) return "0";
  if (num <= 9999) return num.toLocaleString();
  if (num < 1000000) {
    const val = num / 1000;
    return val % 1 === 0 ? `${val}K` : `${val.toFixed(1)}K`;
  }
  const val = num / 1000000;
  return val % 1 === 0 ? `${val}M` : `${val.toFixed(1)}M`;
};

export default formatNumber;
